import { useState, useEffect } from "react";
import heroImage from "./assets/heroImage.webp";

const C = {
  dark: "#1B4332",
  mid: "#2D6A4F",
  sage: "#52796F",
  gold: "#C9A96E",
  cream: "#FAFAF8",
  white: "#FFFFFF",
  light: "#F0F7F3",
  text: "#1A1A1A",
  muted: "#71717A",
  border: "#E4E4E7",
};

const WA =
  "https://api.whatsapp.com/send/?phone=62895415079721&text=Halo+JELANTARA%2C+saya+tertarik+jadi+mitra.+Bisa+info+lebih+lanjut";

function Drop({ size = 24, color = C.gold, style = {} }) {
  return (
    <svg
      width={size}
      height={size * 1.22}
      viewBox="0 0 24 30"
      fill="none"
      style={style}
    >
      <path
        d="M12 1C12 1 1 15 1 20.5C1 25.9 5.9 30 12 30C18.1 30 23 25.9 23 20.5C23 15 12 1 12 1Z"
        fill={color}
      />
    </svg>
  );
}

function WaIcon({ size = 16, color = "white" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492a.75.75 0 00.917.918l4.462-1.496A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22a9.94 9.94 0 01-5.39-1.59.75.75 0 00-.636-.079l-2.758.925.924-2.756a.75.75 0 00-.08-.637A9.94 9.94 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
    </svg>
  );
}

function Arrow() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
      <path
        d="M3 8H13M13 8L9 4M13 8L9 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function BurgerMenu({ isOpen }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {!isOpen ? (
        <>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </>
      ) : (
        <>
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </>
      )}
    </svg>
  );
}

function CtaBanner({ text, subtext, btnText, variant = "dark" }) {
  const isDark = variant === "dark";
  return (
    <section
      style={{
        background: isDark ? C.dark : C.white,
        padding: "56px 32px",
        borderTop: isDark ? "none" : `1px solid ${C.border}`,
        borderBottom: isDark ? "none" : `1px solid ${C.border}`,
      }}
    >
      <div
        style={{
          maxWidth: 920,
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 24,
        }}
        className="cta-content"
      >
        <div>
          <h3
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: isDark ? C.white : C.text,
              margin: "0 0 4px",
            }}
          >
            {text}
          </h3>
          {subtext && (
            <p
              style={{
                fontSize: 13,
                color: isDark ? "rgba(255,255,255,0.45)" : C.muted,
                margin: 0,
              }}
            >
              {subtext}
            </p>
          )}
        </div>
        <div style={{ display: "flex", gap: 10 }} className="cta-btns">
          <a
            href={WA}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              background: isDark ? C.gold : C.dark,
              color: isDark ? C.dark : C.white,
              fontWeight: 600,
              fontSize: 13,
              padding: "12px 28px",
              borderRadius: 6,
              textDecoration: "none",
            }}
          >
            <WaIcon size={15} color={isDark ? C.dark : "white"} />
            {btnText}
          </a>
          <a
            href="tel:+6281234567890"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              fontWeight: 500,
              fontSize: 13,
              padding: "12px 24px",
              borderRadius: 6,
              textDecoration: "none",
              color: isDark ? C.white : C.text,
              border: isDark
                ? "1px solid rgba(255,255,255,0.15)"
                : `1px solid ${C.border}`,
            }}
          >
            Telepon <Arrow />
          </a>
        </div>
      </div>
    </section>
  );
}

function Nav() {
  const [s, setS] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const h = () => setS(window.scrollY > 40);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  return (
    <nav
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        background: s ? "rgba(255,255,255,0.95)" : "transparent",
        backdropFilter: s ? "blur(20px)" : "none",
        borderBottom: s ? `1px solid ${C.border}` : "1px solid transparent",
        transition: "all 0.3s",
      }}
    >
      <div
        style={{
          maxWidth: 1100,
          margin: "0 auto",
          padding: "16px 32px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Drop size={15} color={s ? C.dark : C.gold} />
          <span
            style={{
              fontWeight: 700,
              fontSize: 16,
              color: s ? C.dark : C.white,
              letterSpacing: 3,
              textTransform: "uppercase",
            }}
          >
            Jelantara
          </span>
        </div>

        {/* Desktop Menu */}
        <div
          style={{ display: "flex", gap: 28, alignItems: "center" }}
          className="nav-links"
        >
          {["Mitra", "Kalkulator", "Alur", "Manfaat"].map((t) => (
            <a
              key={t}
              href={`#${t.toLowerCase()}`}
              style={{
                color: s ? C.muted : "rgba(255,255,255,0.65)",
                textDecoration: "none",
                fontSize: 13,
                fontWeight: 500,
              }}
            >
              {t}
            </a>
          ))}
          <a
            href={WA}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              fontSize: 13,
              fontWeight: 600,
              color: C.white,
              textDecoration: "none",
              background: C.dark,
              padding: "9px 22px",
              borderRadius: 6,
            }}
          >
            <WaIcon size={14} /> Hubungi Kami
          </a>
        </div>

        {/* Burger Menu Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          style={{
            display: "none",
            background: "none",
            border: "none",
            cursor: "pointer",
            color: s ? C.dark : C.white,
            padding: 0,
          }}
          className="burger-btn"
        >
          <BurgerMenu isOpen={menuOpen} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div
          style={{
            display: "none",
            backgroundColor: s ? "rgba(255,255,255,0)" : "rgb(41 89 69 / 98%)",
            borderTop: `1px solid ${C.border}`,
            padding: "16px 32px",
          }}
          className="mobile-menu"
        >
          {["Mitra", "Kalkulator", "Alur", "Manfaat"].map((t) => (
            <a
              key={t}
              href={`#${t.toLowerCase()}`}
              onClick={() => setMenuOpen(false)}
              style={{
                display: "block",
                color: s ? C.text : C.white,
                textDecoration: "none",
                fontSize: 14,
                fontWeight: 500,
                padding: "12px 0",
                borderBottom: `1px solid ${
                  s ? C.border : "rgba(255,255,255,0.1)"
                }`,
              }}
            >
              {t}
            </a>
          ))}
          <a
            href={WA}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMenuOpen(false)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              fontSize: 13,
              fontWeight: 600,
              color: C.white,
              textDecoration: "none",
              background: C.dark,
              padding: "10px 20px",
              borderRadius: 6,
              marginTop: "12px",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <WaIcon size={14} /> Hubungi Kami
          </a>
        </div>
      )}
    </nav>
  );
}

function Hero() {
  return (
    <section
      style={{
        minHeight: "100vh",
        background: C.dark,
        display: "flex",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          opacity: 0.04,
          background:
            "radial-gradient(circle at 70% 30%, rgba(201,169,110,0.5) 0%, transparent 50%)",
        }}
      />
      <div
        class="hero-section"
        style={{
          maxWidth: 1100,
          margin: "0 auto",
          padding: "140px 32px 100px",
          position: "relative",
          zIndex: 2,
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 32,
        }}
      >
        <div class="hero-title" style={{ width: "50%" }}>
          <p
            style={{
              fontSize: 11,
              fontWeight: 600,
              color: C.gold,
              letterSpacing: 4,
              textTransform: "uppercase",
              marginBottom: 28,
            }}
          >
            Pengepul UCO Profesional di Medan
          </p>
          <h1
            style={{
              fontSize: 52,
              fontWeight: 700,
              color: C.white,
              lineHeight: 1.12,
              margin: "0 0 24px",
              letterSpacing: -0.5,
            }}
          >
            Jelantah Anda
            <br />
            bernilai <span style={{ color: C.gold }}>uang.</span>
          </h1>
          <p
            style={{
              fontSize: 17,
              color: "rgba(255,255,255,0.5)",
              lineHeight: 1.75,
              marginBottom: 40,
              maxWidth: 460,
            }}
          >
            Kami jemput minyak jelantah dari dapur Anda secara gratis. Diolah
            menjadi biodiesel — bahan bakar masa depan Indonesia.
          </p>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <a
              href={WA}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                background: C.gold,
                color: C.dark,
                fontWeight: 600,
                fontSize: 14,
                padding: "14px 32px",
                borderRadius: 6,
                textDecoration: "none",
              }}
            >
              <WaIcon size={16} color={C.dark} /> Tukar Minyak Jelantah
              Sekarang!
            </a>
            <a
              href="#kalkulator"
              style={{
                background: "transparent",
                color: C.white,
                fontWeight: 500,
                fontSize: 14,
                padding: "14px 32px",
                borderRadius: 6,
                textDecoration: "none",
                border: "1px solid rgba(255,255,255,0.18)",
              }}
            >
              Hitung Nilai Jelantah
            </a>
          </div>

          <div
            style={{ display: "flex", gap: 44, marginTop: 72 }}
            className="hero-stats"
          >
            {[
              ["500+", "Mitra aktif"],
              ["100 ton", "UCO per bulan"],
              ["Gratis", "Biaya pickup"],
              ["< 5 menit", "Respons WA"],
            ].map(([v, l]) => (
              <div key={l}>
                <div
                  class="stats"
                  style={{ fontSize: 22, fontWeight: 700, color: C.white }}
                >
                  {v}
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "rgba(255,255,255,0.3)",
                    marginTop: 4,
                    fontWeight: 500,
                  }}
                >
                  {l}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div class="hero-image" style={{ width: "50%" }}>
          <img
            src={heroImage}
            style={{ width: 500, borderRadius: 20 }}
            alt="Hero Image"
          />
        </div>
      </div>
    </section>
  );
}

function MitraKami() {
  const mitra = [
    {
      title: "Dapur MBG",
      desc: "Mitra resmi dapur Makan Bergizi Gratis (SPPG) di Medan dan sekitarnya. Masak ribuan porsi setiap hari, menghasilkan jelantah dalam volume besar secara rutin.",
      volume: "200 - 500 L/bulan",
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke={C.mid}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 9h18v10a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
          <path d="M3 9l1.5-4.5A2 2 0 016.4 3h11.2a2 2 0 011.9 1.5L21 9" />
          <path d="M12 3v6" />
          <circle cx="7.5" cy="15" r="1.5" />
          <circle cx="16.5" cy="15" r="1.5" />
        </svg>
      ),
    },
    {
      title: "HORECA",
      desc: "Hotel, restoran, dan katering di seluruh Medan. Dari RM Padang, restoran seafood, Chinese food, hingga hotel bintang 3-5 dan katering nikahan.",
      volume: "100 - 1.000 L/bulan",
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke={C.mid}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M18 8h1a4 4 0 010 8h-1" />
          <path d="M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z" />
          <line x1="6" y1="1" x2="6" y2="4" />
          <line x1="10" y1="1" x2="10" y2="4" />
          <line x1="14" y1="1" x2="14" y2="4" />
        </svg>
      ),
    },
    {
      title: "UMKM",
      desc: "Warung nasi, tukang gorengan, kedai kopi, gerobak martabak, warung pecel lele, dan seluruh usaha kuliner kecil-menengah di Medan.",
      volume: "20 - 200 L/bulan",
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke={C.mid}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 3h18v18H3z" />
          <path d="M3 9h18" />
          <path d="M9 21V9" />
          <circle cx="6" cy="6" r="1" fill={C.mid} />
          <path d="M14 15h4" />
          <path d="M14 18h4" />
        </svg>
      ),
    },
    {
      title: "Rumah Tangga",
      desc: "Ibu-ibu RT/RW, bank sampah, dan rumah tangga di seluruh Medan. Kumpulkan jelantah bekas goreng dari dapur rumah melalui titik kumpul agen JELANTARA.",
      volume: "5 - 50 L/bulan",
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke={C.mid}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0a1 1 0 01-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1h-2z" />
        </svg>
      ),
    },
  ];

  return (
    <section id="mitra" style={{ background: C.white, padding: "96px 32px" }}>
      <div style={{ maxWidth: 920, margin: "0 auto" }}>
        <p
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: C.mid,
            letterSpacing: 3,
            textTransform: "uppercase",
            marginBottom: 10,
          }}
        >
          Mitra Kami
        </p>
        <h2
          style={{
            fontSize: 32,
            fontWeight: 700,
            color: C.text,
            margin: "0 0 6px",
          }}
        >
          Kami melayani semua sumber jelantah
        </h2>
        <p style={{ fontSize: 14, color: C.muted, marginBottom: 48 }}>
          Dari dapur MBG sampai dapur rumah — setiap tetes minyak jelantah
          bernilai.
        </p>

        <div
          style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}
          className="grid-2"
        >
          {mitra.map((m, i) => (
            <div
              key={i}
              style={{
                background: C.white,
                borderRadius: 12,
                padding: "32px 28px",
                border: `1px solid ${C.border}`,
                transition: "all 0.25s",
                cursor: "default",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = C.mid;
                e.currentTarget.style.boxShadow =
                  "0 4px 20px rgba(27,67,50,0.08)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = C.border;
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  marginBottom: 16,
                }}
              >
                <div
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: 12,
                    background: C.light,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {m.icon}
                </div>
                <span
                  style={{
                    fontSize: 11,
                    fontWeight: 600,
                    color: C.mid,
                    background: C.light,
                    padding: "5px 12px",
                    borderRadius: 20,
                    letterSpacing: 0.3,
                  }}
                >
                  {m.volume}
                </span>
              </div>
              <h3
                style={{
                  fontSize: 18,
                  fontWeight: 700,
                  color: C.text,
                  margin: "0 0 8px",
                }}
              >
                {m.title}
              </h3>
              <p
                style={{
                  fontSize: 13,
                  color: C.muted,
                  lineHeight: 1.7,
                  margin: 0,
                }}
              >
                {m.desc}
              </p>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 32, textAlign: "center" }}>
          <a
            href={WA}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              background: C.dark,
              color: C.white,
              fontWeight: 600,
              fontSize: 14,
              padding: "14px 36px",
              borderRadius: 6,
              textDecoration: "none",
            }}
          >
            <WaIcon size={16} /> Hubungi Tim Kami
          </a>
          <p style={{ fontSize: 12, color: C.muted, marginTop: 12 }}>
            Apapun skala dapur Anda — kami siap jemput.
          </p>
        </div>
      </div>
    </section>
  );
}

function Calculator() {
  const [liters, setLiters] = useState(100);
  const [freq, setFreq] = useState(4);
  const monthly = liters * freq;
  const value = monthly * 5000;
  const yearly = value * 12;
  return (
    <section
      id="kalkulator"
      style={{ background: C.cream, padding: "96px 32px" }}
    >
      <div style={{ maxWidth: 920, margin: "0 auto" }}>
        <p
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: C.mid,
            letterSpacing: 3,
            textTransform: "uppercase",
            marginBottom: 10,
          }}
        >
          Kalkulator UCO
        </p>
        <h2
          style={{
            fontSize: 32,
            fontWeight: 700,
            color: C.text,
            margin: "0 0 6px",
          }}
        >
          Berapa nilai jelantah Anda?
        </h2>
        <p style={{ fontSize: 14, color: C.muted, marginBottom: 44 }}>
          Geser slider untuk estimasi penghasilan bulanan dari minyak jelantah
          dapur Anda.
        </p>
        <div
          style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}
          className="grid-2"
        >
          <div
            style={{
              padding: "32px 28px",
              background: C.white,
              border: `1px solid ${C.border}`,
              borderRadius: 10,
            }}
          >
            <div style={{ marginBottom: 28 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 12,
                }}
              >
                <span style={{ fontSize: 13, fontWeight: 500, color: C.text }}>
                  Volume per pickup
                </span>
                <span style={{ fontSize: 22, fontWeight: 700, color: C.dark }}>
                  {liters}{" "}
                  <span
                    style={{ fontSize: 12, fontWeight: 500, color: C.muted }}
                  >
                    liter
                  </span>
                </span>
              </div>
              <input
                type="range"
                min={10}
                max={500}
                step={10}
                value={liters}
                onChange={(e) => setLiters(+e.target.value)}
                style={{ width: "100%" }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 10,
                  color: C.muted,
                  marginTop: 4,
                }}
              >
                <span>10 L</span>
                <span>500 L</span>
              </div>
            </div>
            <div style={{ marginBottom: 28 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 12,
                }}
              >
                <span style={{ fontSize: 13, fontWeight: 500, color: C.text }}>
                  Pickup per bulan
                </span>
                <span style={{ fontSize: 22, fontWeight: 700, color: C.dark }}>
                  {freq}
                  <span
                    style={{ fontSize: 12, fontWeight: 500, color: C.muted }}
                  >
                    x
                  </span>
                </span>
              </div>
              <input
                type="range"
                min={1}
                max={8}
                step={1}
                value={freq}
                onChange={(e) => setFreq(+e.target.value)}
                style={{ width: "100%" }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 10,
                  color: C.muted,
                  marginTop: 4,
                }}
              >
                <span>1x/bulan</span>
                <span>8x/bulan</span>
              </div>
            </div>
            <div
              style={{
                background: C.cream,
                borderRadius: 6,
                padding: "12px 16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 24,
              }}
            >
              <span style={{ fontSize: 12, color: C.muted }}>Harga beli</span>
              <span style={{ fontSize: 14, fontWeight: 600, color: C.dark }}>
                Rp 6.000/liter
              </span>
            </div>
            <span
              style={{
                fontSize: 13,
                fontWeight: 500,
                color: C.text,
                float: "right",
              }}
            >
              (Harga dapat berubah, hubungi Admin!)
            </span>
          </div>
          <div
            style={{
              background: C.dark,
              borderRadius: 10,
              padding: "32px 28px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div>
              <p
                style={{
                  fontSize: 10,
                  fontWeight: 600,
                  color: "rgba(255,255,255,0.3)",
                  letterSpacing: 2,
                  textTransform: "uppercase",
                  marginBottom: 24,
                }}
              >
                Estimasi penghasilan
              </p>
              <div style={{ marginBottom: 20 }}>
                <p
                  style={{
                    fontSize: 11,
                    color: C.gold,
                    marginBottom: 2,
                    fontWeight: 500,
                  }}
                >
                  Volume per bulan
                </p>
                <p
                  style={{
                    fontSize: 28,
                    fontWeight: 700,
                    color: C.white,
                    margin: 0,
                  }}
                >
                  {monthly.toLocaleString("id-ID")}{" "}
                  <span
                    style={{
                      fontSize: 13,
                      fontWeight: 400,
                      color: "rgba(255,255,255,0.35)",
                    }}
                  >
                    liter
                  </span>
                </p>
              </div>
              <div
                style={{
                  height: 1,
                  background: "rgba(255,255,255,0.07)",
                  margin: "0 0 20px",
                }}
              />
              <div style={{ marginBottom: 20 }}>
                <p
                  style={{
                    fontSize: 11,
                    color: C.gold,
                    marginBottom: 2,
                    fontWeight: 500,
                  }}
                >
                  Per bulan
                </p>
                <p
                  style={{
                    fontSize: 38,
                    fontWeight: 700,
                    color: C.gold,
                    margin: 0,
                    letterSpacing: -1,
                  }}
                >
                  Rp {value.toLocaleString("id-ID")}
                </p>
              </div>
              <div>
                <p
                  style={{
                    fontSize: 11,
                    color: "rgba(255,255,255,0.3)",
                    marginBottom: 2,
                    fontWeight: 500,
                  }}
                >
                  Per tahun
                </p>
                <p
                  style={{
                    fontSize: 20,
                    fontWeight: 600,
                    color: C.white,
                    margin: 0,
                  }}
                >
                  Rp {yearly.toLocaleString("id-ID")}
                </p>
              </div>
            </div>
            <a
              href={WA}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                background: C.gold,
                color: C.dark,
                fontWeight: 600,
                fontSize: 13,
                padding: "13px 24px",
                borderRadius: 6,
                textDecoration: "none",
                marginTop: 24,
              }}
            >
              <WaIcon size={15} color={C.dark} /> Tukar Minyak Jelantah
              Sekarang!
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function Flow() {
  const steps = [
    {
      n: "01",
      t: "Hubungi kami",
      d: "WA ke JELANTARA, daftarkan dapur Anda. Gratis, tanpa biaya pendaftaran.",
    },
    {
      n: "02",
      t: "Terima jirigen",
      d: "Kami antar jirigen ke lokasi Anda. Lengkap filter saringan dan panduan SOP.",
    },
    {
      n: "03",
      t: "Kumpulkan jelantah",
      d: "Tuang jelantah ke jirigen setelah dingin. Saring, tutup rapat, isi maks 80%.",
    },
    {
      n: "04",
      t: "Kami jemput & bayar",
      d: "Tim datang sesuai jadwal. Timbang di depan Anda, isi nota, bayar tunai.",
    },
    {
      n: "05",
      t: "Jadi biodiesel",
      d: "Jelantah diolah menjadi biodiesel B100 — kurangi emisi CO2 hingga 92%.",
    },
  ];
  return (
    <section id="alur" style={{ background: C.white, padding: "96px 32px" }}>
      <div style={{ maxWidth: 920, margin: "0 auto" }}>
        <p
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: C.mid,
            letterSpacing: 3,
            textTransform: "uppercase",
            marginBottom: 10,
          }}
        >
          Cara kerja
        </p>
        <h2
          style={{
            fontSize: 32,
            fontWeight: 700,
            color: C.text,
            margin: "0 0 6px",
          }}
        >
          Semudah 5 langkah
        </h2>
        <p style={{ fontSize: 14, color: C.muted, marginBottom: 48 }}>
          Dari dapur Anda ke tangki biodiesel — kami yang urus semuanya.
        </p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 12,
            marginBottom: 12,
          }}
          className="grid-3"
        >
          {steps.slice(0, 3).map((s, i) => (
            <div
              key={i}
              style={{
                background: C.cream,
                borderRadius: 10,
                padding: "28px 24px",
                border: `1px solid ${C.border}`,
                position: "relative",
              }}
            >
              <span
                style={{
                  fontSize: 44,
                  fontWeight: 700,
                  color: C.border,
                  position: "absolute",
                  top: 16,
                  right: 20,
                  lineHeight: 1,
                }}
              >
                {s.n}
              </span>
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 8,
                  background: C.light,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 16,
                }}
              >
                <Drop size={13} color={C.mid} />
              </div>
              <h3
                style={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: C.text,
                  margin: "0 0 6px",
                }}
              >
                {s.t}
              </h3>
              <p
                style={{
                  fontSize: 12,
                  color: C.muted,
                  lineHeight: 1.65,
                  margin: 0,
                }}
              >
                {s.d}
              </p>
            </div>
          ))}
        </div>
        <div
          style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}
        >
          {steps.slice(3).map((s, i) => (
            <div
              key={i}
              style={{
                background: i === 1 ? C.dark : C.cream,
                borderRadius: 10,
                padding: "28px 24px",
                border: i === 1 ? "none" : `1px solid ${C.border}`,
                position: "relative",
              }}
            >
              <span
                style={{
                  fontSize: 44,
                  fontWeight: 700,
                  color: i === 1 ? "rgba(255,255,255,0.05)" : C.border,
                  position: "absolute",
                  top: 16,
                  right: 20,
                  lineHeight: 1,
                }}
              >
                {s.n}
              </span>
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 8,
                  background: i === 1 ? "rgba(201,169,110,0.12)" : C.light,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 16,
                }}
              >
                <Drop size={13} color={i === 1 ? C.gold : C.mid} />
              </div>
              <h3
                style={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: i === 1 ? C.white : C.text,
                  margin: "0 0 6px",
                }}
              >
                {s.t}
              </h3>
              <p
                style={{
                  fontSize: 12,
                  color: i === 1 ? "rgba(255,255,255,0.45)" : C.muted,
                  lineHeight: 1.65,
                  margin: 0,
                }}
              >
                {s.d}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Benefits() {
  const items = [
    {
      t: "Penghasilan tambahan",
      d: "Jelantah yang tadinya dibuang jadi uang. Rata-rata mitra menghasilkan Rp 500K — 2 jt per bulan.",
    },
    {
      t: "Dapur lebih bersih",
      d: "Tidak ada lagi jelantah menumpuk. Jirigen rapi, tertutup, dan tidak bau.",
    },
    {
      t: "Lindungi lingkungan",
      d: "1 liter jelantah mencemari 1 juta liter air. Jual ke kami, selamatkan lingkungan.",
    },
    {
      t: "Energi terbarukan",
      d: "Diolah jadi biodiesel B100 — kurangi emisi karbon 92% dibanding solar fosil.",
    },
    {
      t: "Pickup gratis terjadwal",
      d: "Tim kami datang sesuai jadwal. Tidak perlu repot — bahkan untuk volume kecil.",
    },
    {
      t: "Transparan & adil",
      d: "Timbang digital di depan Anda. Nota lengkap, bayar tunai. Tanpa potongan.",
    },
  ];
  return (
    <section id="manfaat" style={{ background: C.cream, padding: "96px 32px" }}>
      <div style={{ maxWidth: 920, margin: "0 auto" }}>
        <p
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: C.mid,
            letterSpacing: 3,
            textTransform: "uppercase",
            marginBottom: 10,
          }}
        >
          Keuntungan
        </p>
        <h2
          style={{
            fontSize: 32,
            fontWeight: 700,
            color: C.text,
            margin: "0 0 6px",
          }}
        >
          Kenapa pilih JELANTARA?
        </h2>
        <p style={{ fontSize: 14, color: C.muted, marginBottom: 48 }}>
          Bukan cuma uang — dapur lebih bersih, bumi lebih hijau.
        </p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 0,
            border: `1px solid ${C.border}`,
            borderRadius: 10,
            overflow: "hidden",
          }}
        >
          {items.map((b, i) => (
            <div
              key={i}
              style={{
                padding: "28px 28px",
                background: C.white,
                borderBottom: i < 4 ? `1px solid ${C.border}` : "none",
                borderRight: i % 2 === 0 ? `1px solid ${C.border}` : "none",
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = C.cream)}
              onMouseLeave={(e) => (e.currentTarget.style.background = C.white)}
            >
              <div
                style={{ display: "flex", gap: 14, alignItems: "flex-start" }}
              >
                <div
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 6,
                    background: C.light,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    marginTop: 1,
                  }}
                >
                  <Drop size={12} color={C.mid} />
                </div>
                <div>
                  <h3
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: C.text,
                      margin: "0 0 4px",
                    }}
                  >
                    {b.t}
                  </h3>
                  <p
                    style={{
                      fontSize: 12,
                      color: C.muted,
                      lineHeight: 1.65,
                      margin: 0,
                    }}
                  >
                    {b.d}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Stats() {
  return (
    <section style={{ background: C.white, padding: "64px 32px" }}>
      <div
        style={{
          maxWidth: 920,
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 16,
        }}
        className="grid-4"
      >
        {[
          ["3 juta", "Kiloliter UCO terbuang/tahun di Indonesia"],
          ["92%", "Pengurangan emisi CO2 dari biodiesel"],
          ["1 juta", "Liter air tercemar per 1L jelantah"],
          ["B50", "Mandatori biodiesel mulai Juli 2026"],
        ].map(([v, l]) => (
          <div key={l} style={{ textAlign: "center", padding: "24px 12px" }}>
            <div
              style={{
                fontSize: 28,
                fontWeight: 700,
                color: C.dark,
                marginBottom: 6,
              }}
            >
              {v}
            </div>
            <div style={{ fontSize: 11, color: C.muted, lineHeight: 1.5 }}>
              {l}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function FinalCTA() {
  return (
    <section style={{ background: C.cream, padding: "96px 32px" }}>
      <div style={{ maxWidth: 560, margin: "0 auto", textAlign: "center" }}>
        <Drop
          size={24}
          color={C.gold}
          style={{ marginBottom: 20, display: "inline-block" }}
        />
        <h2
          style={{
            fontSize: 36,
            fontWeight: 700,
            color: C.text,
            margin: "0 0 12px",
            lineHeight: 1.2,
          }}
        >
          Tukar jelantah,
          <br />
          terima manfaat.
        </h2>
        <p
          style={{
            fontSize: 15,
            color: C.muted,
            lineHeight: 1.7,
            marginBottom: 32,
          }}
        >
          Daftar jadi mitra sekarang. Gratis, tanpa syarat. Kami yang jemput ke
          lokasi Anda.
        </p>
        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <a
            href={WA}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              background: C.dark,
              color: C.white,
              fontWeight: 600,
              fontSize: 14,
              padding: "14px 32px",
              borderRadius: 6,
              textDecoration: "none",
            }}
          >
            <WaIcon size={16} /> Hubungi Tim Kami
          </a>
          <a
            href="tel:+6281234567890"
            style={{
              fontWeight: 500,
              fontSize: 14,
              color: C.text,
              textDecoration: "none",
              padding: "14px 32px",
              borderRadius: 6,
              border: `1px solid ${C.border}`,
            }}
          >
            Telepon Kami
          </a>
        </div>
        <p style={{ fontSize: 12, color: C.muted, marginTop: 20 }}>
          Atau WA langsung ke{" "}
          <strong style={{ color: C.dark }}>0895-4150-79721</strong>
        </p>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer
      style={{
        borderTop: `1px solid ${C.border}`,
        padding: "28px 32px",
        background: C.white,
      }}
    >
      <div
        style={{
          maxWidth: 1100,
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Drop size={12} color={C.dark} />
          <span
            style={{
              fontWeight: 700,
              fontSize: 13,
              color: C.text,
              letterSpacing: 2,
              textTransform: "uppercase",
            }}
          >
            Jelantara
          </span>
        </div>
        <span style={{ fontSize: 11, color: C.muted }}>
          2026 PT Jelantara Energi Nusantara
        </span>
      </div>
    </footer>
  );
}

export default function App() {
  return (
    <div
      style={{
        fontFamily: "'Montserrat', sans-serif",
        margin: 0,
        color: C.text,
      }}
    >
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');`}</style>
      <style>{`*{margin:0;padding:0;box-sizing:border-box}html{scroll-behavior:smooth}body{margin:0;-webkit-font-smoothing:antialiased}input[type=range]{-webkit-appearance:none;appearance:none;height:4px;border-radius:2px;background:#E4E4E7;outline:none;cursor:pointer}input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;width:18px;height:18px;border-radius:50%;background:${C.dark};cursor:pointer;border:2.5px solid white;box-shadow:0 1px 4px rgba(0,0,0,0.12)}
      @media (min-width: 768.98px) and (max-width: 1024px){.hero-title{width:60%!important}.hero-image{width:40%!important}.hero-stats{gap:30px!important}.stats{font-size:18px!important}}
      @media (max-width: 768px){.hero-section{flex-direction:column;gap:50px!important; padding:140px 24px 100px!important}.hero-title h1{font-size:28px!important}.hero-title,.hero-image{width:100%!important}.hero-stats{margin-top:40px!important}.hero-stats>div{width:45%!important}.stats{font-size:18px!important}.hero-image img{width:100%!important;height: 300px;object-fit: cover;object-position: 0% 30%;}.nav-links{display:none!important}.burger-btn{display:block!important}.mobile-menu{display:block!important;background-color: rgb(41 89 69 / 98%);border-radius: 20px;margin: 0 2rem;}nav{max-width:100%!important}h1{font-size:32px!important;line-height:1.2!important}h2{font-size:24px!important}p{font-size:14px!important}.grid-2{grid-template-columns:1fr!important;gap:16px!important}.grid-3{grid-template-columns:1fr!important}.grid-4{grid-template-columns:repeat(2,1fr)!important}section{padding:48px 16px!important}.hero-stats{gap:28px!important}.cta-content{flex-direction:column!important;gap:16px!important}}
      @media (max-width: 480px){section{padding:32px 16px!important}h1{font-size:24px!important}h2{font-size:20px!important}p{font-size:13px!important}.hero-stats{flex-wrap:wrap!important;justify-content: center!important;gap:16px!important;margin-top:40px!important}.grid-2{grid-template-columns:1fr!important}.grid-4{grid-template-columns:1fr!important}.cta-btns{flex-direction:column!important;width:100%!important}.cta-btns a{width:100%!important;justify-content:center!important}}
      `}</style>
      <Nav />
      <Hero />
      <MitraKami />
      <CtaBanner
        text="Punya restoran atau warung di Medan?"
        subtext="Jelantah Anda bisa jadi penghasilan tambahan setiap bulan."
        btnText="Tukar Minyak Jelantah Sekarang!"
        variant="dark"
      />
      <Calculator />
      <CtaBanner
        text="Siap mulai? Prosesnya cuma 5 menit."
        subtext="Daftar hari ini, besok kami antar jirigen ke lokasi Anda."
        btnText="Hubungi Tim Kami"
        variant="light"
      />
      <Flow />
      <Benefits />
      <Stats />
      <CtaBanner
        text="500+ mitra sudah bergabung."
        subtext="Jangan biarkan jelantah Anda terbuang sia-sia."
        btnText="Tukar Minyak Jelantah Sekarang!"
        variant="dark"
      />
      <FinalCTA />
      <Footer />
    </div>
  );
}
